import { post } from "@app/common/api";
import type { WorkspaceSearchResponse } from "@app/common/types";
import type { WorkspaceEntityKind } from "@app/common/types";
import { withQueryParamsUrl } from "@app/common/utils";

export interface WorkspaceSearchParams {
  query: string;
  includeEntities?: WorkspaceEntityKind[];
}

export const searchWorkspace = async (
  workspaceId: string,
  params: WorkspaceSearchParams
): Promise<WorkspaceSearchResponse> => {
  const url = withQueryParamsUrl(
    `/enterprise/workspaces/${workspaceId}/search`,
    { query: params.query, include_entity: params.includeEntities }
  );
  const json = await post(url, {}, { withCreds: true });
  return json as WorkspaceSearchResponse;
};
